export class EventManager {
    constructor() {
        this._listeners = [];
    }
    addListener(eventKind, listener) {
        let listen = {
            kind: eventKind,
            listener
        };
        this._listeners.push(listen);
        return () => {
            this._listeners.splice(this._listeners.indexOf(listen), 1);
        };
    }
    fire(event, param) {
        return this._listeners.filter(value => value.kind === event).map(value => value.listener(param));
    }
}
//# sourceMappingURL=EventManager.js.map